import { MenuUnfoldOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { IWorkspace } from '../../../DataSource/Stores/Cabinet/WorkspacesStoreActionsClass';
import LayoutStore from '../../../DataSource/Stores/LayoutStore';
import { pluralize } from '../../../utils';
import Clickable from '../../ui/Clickable';
import * as styles from './Item.module.scss';

const CATEGORY_LABELS: Record<string, string> = {
  order_management: 'Центр распределения',
  order_management_default: 'Центр распределения',
  delivery_center: 'Доставка',
  inventors: 'Инвентарь',
  hotel: 'Отель',
  aiAssistant: 'AI Ассистент',
  franchize: 'Франшиза',
  iiko_dashboard: 'iiko Dashboard',
};

export { CATEGORY_LABELS };

const Item = ({ workspace }: { workspace: IWorkspace }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.workspace_card}>
      {/*<IconButton*/}
      {/*  className={styles.workspace_card_settings}*/}
      {/*  variant="clear"*/}
      {/*  icon="fi-rr-menu-dots"*/}
      {/*  onClick={() => LayoutStore.openModal('workspaceSettings', { workspace })}*/}
      {/*/>*/}
      <Button
        size={'small'}
        className={styles.workspace_card_settings}
        onClick={() => LayoutStore.openModal('workspaceSettings', { workspace })}
      >
        <MenuUnfoldOutlined />
      </Button>
      <Clickable
        className={styles.workspace_card_body}
        onClick={() => {
          if (workspace.category === 'order_management') navigate(`/workspaces/${workspace._id}`);
          if (workspace.category === 'inventors') navigate(`/workspaces/${workspace._id}`);
          if (workspace.category === 'hotel') navigate(`/workspaces/${workspace._id}`);
          if (workspace.category === 'delivery_center') navigate(`/workspaces/${workspace._id}`);
          if (workspace.category === 'order_management_default')
            navigate(`/workspaces/${workspace._id}`);
          if (workspace.category === 'aiAssistant')
            window.location.href = `/aida/${workspace._id}/schedule`;
          if (workspace.category === 'franchize')
            window.location.href = `/franchize/${workspace._id}`;
          if (workspace.category === 'iiko_dashboard')
            window.location.href = `/iiko_dashboard/${workspace._id}`;
        }}
      >
        <div className={styles.workspace_card_avatar}>{workspace.name.charAt(0).toUpperCase()}</div>
        <div className={styles.workspace_card_name}>{workspace.name}</div>
        <div className={styles.workspace_card_category}>
          {CATEGORY_LABELS[workspace.category] ?? workspace.category}
        </div>
        <div className={styles.workspace_card_members}>
          {pluralize(workspace.members.length || 0, ['участник', 'участника', 'участников'])}
        </div>
      </Clickable>
    </div>
  );
};

export default observer(Item);
